import { useCallback, useEffect, useId } from "react";
export const useAnnounce = ({ delayInMs, } = { delayInMs: 0 }) => {
    const announcementsContainerId = "announcements-container";
    const id = useId();
    useEffect(() => {
        const el = document.createElement("div");
        el.id = id;
        let announcementsContainer = document.getElementById(announcementsContainerId);
        if (!announcementsContainer) {
            announcementsContainer = document.createElement("div");
            announcementsContainer.id = announcementsContainerId;
            announcementsContainer.setAttribute("role", "region");
            announcementsContainer.setAttribute("aria-live", "polite");
            announcementsContainer.className = "sr-only";
            document.body.appendChild(announcementsContainer);
        }
        announcementsContainer.appendChild(el);
        return () => {
            announcementsContainer.removeChild(el);
        };
    }, []);
    return useCallback((text) => {
        const createNotification = () => {
            const el = document.getElementById(id);
            if (el) {
                el.textContent = "";
                el.textContent = text;
            }
        };
        if (delayInMs > 0) {
            setTimeout(createNotification, delayInMs);
        }
        else {
            createNotification();
        }
    }, [id]);
};
//# sourceMappingURL=useAnnounce.js.map